// extracted by mini-css-extract-plugin
export var oProblem = "problem-module--o-problem--3xvWS";
export var lContent__inner = "problem-module--l-content__inner--27bPa";
export var oProblem__list = "problem-module--o-problem__list--39ocR";
export var oProblem__decorationCharactor = "problem-module--o-problem__decoration--charactor--4Xubm";
export var oProblem__decorationOnayami = "problem-module--o-problem__decoration--onayami--20qvO";
export var visible = "problem-module--visible--14D2l";
export var problem__list = "problem-module--problem__list--3hfn0";
export var standby = "problem-module--standby--OTGcj";